import { Button } from '@wundo/ui';
import { Check, Copy } from 'lucide-react';
import { m } from '@/paraglide/messages.js';

export interface MeetingCopyButtonProps {
  /** Whether the copy just landed, so the button can say so for a moment. */
  copied: boolean;
  onCopy: () => void;
}

/**
 * Taking the document off the page. It sits beside the card's title because
 * that is where a document's own actions are looked for — at the top of what
 * they act on, not under the end of it.
 */
export function MeetingCopyButton({ copied, onCopy }: MeetingCopyButtonProps) {
  return (
    <Button size='sm' variant='quiet' onClick={onCopy}>
      {copied ? (
        <Check className='size-4' aria-hidden='true' />
      ) : (
        <Copy className='size-4' aria-hidden='true' />
      )}
      {copied ? m.meeting_report_copied() : m.meeting_document_copy()}
    </Button>
  );
}
